import { Layout, Spin } from "antd";
import { BaseAnimation as BaseAnimationComponent } from "./BaseAnimation";

const { Content } = Layout;

export const Loading = ({
	spinning,
	children,
}: {
	spinning: boolean;
	children?: React.ReactNode;
}) => (
	<div className="flex min-h-full w-full flex-col">
		<Spin spinning={spinning} className="fixed !max-h-none [z-index:1001]">
			<BaseAnimationComponent>
				<Layout className="min-h-screen">
					<Content className="bg-white">
						{/* <div>Loading component...</div> */}
						{children}
					</Content>
				</Layout>
			</BaseAnimationComponent>
		</Spin>
	</div>
);
